import { render } from "./CopilotChatViewer.vue?vue&type=template&id=100236d7&scoped=true&ts=true"
import script from "./CopilotChatViewer.vue?vue&type=script&lang=ts"
export * from "./CopilotChatViewer.vue?vue&type=script&lang=ts"

import "./CopilotChatViewer.vue?vue&type=style&index=0&id=100236d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-100236d7"]])

export default __exports__